import { useState } from 'react';
import { Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { LazyFAQModal } from './LazyModals';

const MobileFooter = () => {
  const [isFAQOpen, setIsFAQOpen] = useState(false);
  
  return (<>
    <footer className="bg-gray-50 border-t border-gray-200 mt-12 md:hidden">
      <div className="px-4 py-4">
        {/* Company Name */}
        <div className="text-center mb-3">
          <div className="flex items-center justify-center space-x-2 mb-2">
            <img src="/images/logo.svg" alt="홀씨" className="h-6 w-auto" />
            <span className="text-lg font-bold text-gray-900">홀씨 트레킹</span>
          </div>
          <p className="text-xs text-gray-600">
            액티브 시니어를 위한 프리미엄 트레킹 투어 서비스
          </p>
        </div>

        {/* Contact Info */}
        <div className="flex items-center justify-center space-x-2 text-sm text-gray-600 mb-3">
          <Phone size={14} />
          <span>1588-0000</span>
        </div>

        {/* Essential Links */}
        <div className="text-center text-xs text-gray-600 mb-3">
          <div className="flex justify-center space-x-3 mb-2">
            <button 
              onClick={() => setIsFAQOpen(true)}
              className="hover:text-[#F39800] transition-colors"
            >
              자주 묻는 질문
            </button>
            <span className="text-gray-400">|</span>
            <Link to="/refund-policy" className="hover:text-[#F39800] transition-colors">
              취소/환불안내
            </Link>
          </div>
          <div className="flex justify-center space-x-3">
            <a href="/terms" className="hover:text-[#F39800] transition-colors">
              이용약관
            </a>
            <span className="text-gray-400">|</span>
            <a href="/privacy" className="hover:text-[#F39800] transition-colors">
              개인정보처리방침
            </a>
            <span className="text-gray-400">|</span>
            <a href="/location-terms" className="hover:text-[#F39800] transition-colors">
              위치정보이용약관
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-xs text-gray-500 border-t border-gray-200 pt-3">
          © 2024 홀씨(Wholsee). All rights reserved.
        </div>
      </div>
    </footer>
    <LazyFAQModal isOpen={isFAQOpen} onClose={() => setIsFAQOpen(false)} />
  </>);
};

export default MobileFooter;